// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mBknzNR{max-width:280px}.zh0AmLf{padding:1.875em 2.375em 1em;text-align:center}@media(max-width: 899px){.zh0AmLf{padding:.875em 1.375em 1em}}.FTuLNc6,.mBknzNR .FTuLNc6{font-size:24px;line-height:1.4}@media(max-width: 899px){.FTuLNc6,.mBknzNR .FTuLNc6{font-size:20px}}.E11t1Ux{display:flex;justify-content:center;align-items:center;padding:2em 2.375em 2.375em}@media(max-width: 899px){.E11t1Ux{padding:1em 1.375em}}.retdzqy,.mBknzNR .retdzqy{margin-right:.5em;margin-left:.5em;padding-right:2em;padding-left:2em}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `mBknzNR`,
	"header": `zh0AmLf`,
	"title": `FTuLNc6`,
	"footer": `E11t1Ux`,
	"button": `retdzqy`
};
export default ___CSS_LOADER_EXPORT___;
